import { VillaSpecificationsPropertiesTypes } from "@website/accommodation-ui/villa-specifications/villa-specifications.types";
import { MaterialIcon } from "@website/icons/material";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = ({
  villaSpecifications
}: VillaSpecificationsPropertiesTypes) => {
  const router = useRouter();
  if (!villaSpecifications?.length) return null;
  return (
    <div className="flex flex-col gap-4" id="hotel_specifications">
      <div className="text-subtitle-1 md:text-headline-6">مشخصات اقامتگاه</div>
      <div className="grid grid-cols-1 gap-x-2 gap-y-6 md:grid-cols-2 md:gap-y-2">
        {villaSpecifications?.map(({ iconName, title, description }) => (
          <div className="md:border-outline-thin flex w-full flex-row items-center gap-2 rounded-lg md:border md:p-6">
            <div>
              <MaterialIcon
                className="text-headline-4 text-on-surface-medium-emphasis size-[30px] md:size-[32px]"
                name={iconName}
                variant="outlined"
              />
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-subtitle-2">{title}</span>
              <span className="text-body-2 text-on-surface-medium-emphasis">
                {numberConvert(description, { locale: router?.locale })}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export const VillaSpecifications = memo(Component, deepCompare);
